<template>
    <div>
        <template v-if="isPageAllowed">
            <router-view/>
        </template>
        <template v-else>
            <NoPermissionInfo style="background-color: #fff;">
                <p>{{pageInfoText}}</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import API from '@/api/home.js';
import NoPermissionInfo from '@/components/noPermissionInfo';
export default {
  components: { NoPermissionInfo },
    data(){
      return {
          pageInfoText:'',
          isPageAllowed:true,
          pageFields:[],
          rawFields:[],
          pageFunc:[],
          pageDimension:[],
          pageSpecialFunc:[],
          dataDays:'',
          allowedPlatList:[],
          mixinLoading:false,
          pageAction:[],
      }
    },
    created(){
        let routeMeta = this.$route.meta;
        console.log('routeMeta',routeMeta,this.$route);
        this.pageInfoText = routeMeta.desc;
        if(routeMeta.isRouterView){
            this.getPageAllowAction();
        }
    },
    methods:{
        getPageAllowAction(){
            let routeMeta = this.$route.meta;
            /* tab页 需要用pid来请求页面权限 */
            let navId = routeMeta.isTabItem?routeMeta.pid:routeMeta.id;
            console.log('getPageAllowAction',navId,routeMeta);
            if(navId){
                this.mixinLoading = true;
                API.getPageAllowAction({
                    action_id:navId,
                }).then(res => {
                    let resData = res.data||{};
                    console.log(1111,resData);

                    this.dataDays = resData.data_days;
                    let actionData = resData.page_action||[];
                    let platList = resData.plat_list||[];
                    this.pageAction = actionData;

                    if(platList.length>0){
                        this.allowedPlatList = platList;
                    }


                    if(actionData.length<=0){
                        this.isPageAllowed = false;
                        this.pageFields = [];
                        this.rawFields = [];
                        this.pageFunc = [];
                        this.pageDimension = [];
                        this.pageSpecialFunc = [];
                        this.pageAction = [];
                    }else if(routeMeta.isTabItem){

                        let pageName = this.$route.name;
                        let pageItem = actionData.find(item=>item.name==pageName);
                        this.isPageAllowed = !!pageItem;
                        if(pageItem){
                            this.pageFields = this._getFlatArray(pageItem.fields,[]);
                            this.rawFields = pageItem.fields;
                            this.pageFunc = pageItem.func;
                            this.pageDimension = pageItem.dimension;
                            this.pageSpecialFunc = pageItem.special_func;
                        }
                    }else{
                        this.isPageAllowed = true;
                        this.pageFields = this._getFlatArray(actionData[0].fields,[]);
                        this.rawFields = actionData[0].fields;
                        this.pageFunc = actionData[0].func;
                        this.pageDimension = actionData[0].dimension;
                        this.pageSpecialFunc = actionData[0].special_func;


                        let dailyTaskPage = actionData.find(item=>item.name=='daily_task_page');
                        if(dailyTaskPage){
                            let periodConfig = dailyTaskPage.statistical_period||[];
                            this.$store.commit('dailyTask/UPDATE_PERIOD_CONFIG', periodConfig);
                        }
                    }

                    /* initPageStates方法需要在宿主页面里定义后才能正确调用 */
                    if(this.initPageStates){
                        this.initPageStates();
                    }
                    this.mixinLoading = false;
                }, (err) => {
                    console.log('getPageAllowAction error', err);
                    this.isPageAllowed = false;
                    this.pageFields = [];
                    this.rawFields = [];
                    this.pageFunc = [];
                    this.pageDimension = [];
                    this.pageSpecialFunc = [];
                    this.mixinLoading = false;
                    this.pageAction = [];
                });
            }
        },
        _getFlatArray(list,result){
            list.forEach(item=>{
                if(!item.children){
                    result.push(item);
                }else if(item.children&&item.children.length>0){
                    return this._getFlatArray(item.children,result);
                }
            });
            return result;
        },
    },

}
</script>

<style>

</style>
